import { render, staticRenderFns } from "./PopupDeliveryList.vue?vue&type=template&id=5e8b7262&"
import script from "./PopupDeliveryList.vue?vue&type=script&lang=js&"
export * from "./PopupDeliveryList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports